'use client'

import { useMemo } from "react"
import ProductCard from "../product/ProductCard"
import { ChevronRight, PackageOpen } from "lucide-react"
import { Button } from "@/components/elements/Button"
import EmptyState from "@/components/elements/EmptyState"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function Products({ products, vendor, title, limit, description, viewAllUrl }: { products: any[], vendor: any, wishlist?: any, title: string, limit?: number, description?: string, viewAllUrl?: string }) {
  const pathname = usePathname()

  const isWideRatio = vendor?.imageAspectRatio === '16/9'
  const gridCols = isWideRatio ? 'lg:grid-cols-4' : 'lg:grid-cols-5'

  const desktopCount = isWideRatio ? 12 : 10
  const mobileCount = 10
  const mediumCount = 12
  const itemCount = limit || Math.max(mobileCount, mediumCount, desktopCount)

  const displayProducts = useMemo(() => {
    return (products || []).slice(0, itemCount)
  }, [products, itemCount])

  return (
    <div className="cont py-4 sm:py-8">
      <div className="flex items-center justify-between gap-2 mb-4">
        <div className="flex flex-col gap-1">
          <div className="text-foreground text-xl sm:text-3xl leading-6 sm:leading-9 font-semibold tracking-[-0.75%]">{title}</div>
          {description && <div className="text-muted-foreground font-normal text-sm leading-5 sm:text-lg sm:leading-7 tracking-[.0125em]">{description}</div>}
        </div>
        {viewAllUrl && displayProducts.length > 0 && (
          <div className="hidden sm:block">
            <Button tag="a" href={navigateUrl(viewAllUrl, pathname)} variant="ghost" icon={ChevronRight} iconPosition="right">
              Бүгдийг харах
            </Button>
          </div>
        )}
      </div>
      {displayProducts.length > 0 ? (
        <>
          <div className={`grid grid-cols-2 md:grid-cols-4 ${gridCols} gap-x-4 gap-y-10 mt-4`}>
            {displayProducts.map((product: any, index: number) => {
              const showOnMobile = index < mobileCount
              const showOnMedium = index < mediumCount
              const showOnDesktop = index < desktopCount
              return (
                <div key={product.customId} className={`${showOnMobile ? 'block' : 'hidden'} ${showOnMedium ? 'md:block' : 'md:hidden'} ${showOnDesktop ? 'lg:block' : 'lg:hidden'}`}>
                  <ProductCard product={product} vendor={vendor} />
                </div>
              )
            })}
          </div>
          {viewAllUrl && (
            <div className="flex items-center justify-center sm:hidden mt-10">
              <Button tag="a" href={navigateUrl(viewAllUrl, pathname)} variant="outline" width="full" icon={ChevronRight} iconPosition="right">
                Бүгдийг харах
              </Button>
            </div>
          )}
        </>
      ) : (
        <EmptyState icon={PackageOpen} title="Бүтээгдэхүүн байхгүй байна" description="Яг одоогоор энэ төрлийн бүтээгдэхүүн байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу." />
      )}
    </div>
  )
}
